import { successNotifyService, failureNotifyService } from '@/services/errors.service.js';
import { isInteger } from 'core-js/fn/number';
import { isBoolean } from 'lodash';
import axios from 'axios'

export function checkInputFieldService(localData, action) {
    let cfObj = {};
    cfObj.fieldValueIsNull = false; // Default
    cfObj.collectionName = 'offers';
    cfObj.vuexServiceName = 'editor';

    //////////////////////////////////////
    /// Offers Collection Mapping
    //////////////////////////////////////

    if (action === "saveOfferPrice") {
        cfObj.fieldName = 'price';
    } else if (action === "saveOfferTitle" && localData.title) {
        cfObj.fieldName = 'title';
    } else if (action === "saveOfferShortDescription") {
        cfObj.fieldName = 'shortDescription';
    } else if (action === 'saveOfferDescription') {
        cfObj.fieldName = 'description';
    } else if (action === 'saveOfferFormat') {
        cfObj.fieldName = 'format';
    } else if (action === 'saveOfferDuration') {
        cfObj.fieldName = 'duration';
    } else if (action === 'saveOfferOrganization') {
        cfObj.fieldName = 'organization';
    } else if (action === 'saveOfferOrganizationId') {
        cfObj.fieldName = 'organization_id';
    
    // --- NEW FIELDS ADDED HERE ---
    } else if (action === 'saveOfferValuePromise') {
        cfObj.fieldName = 'valuePromise';
    } else if (action === 'saveOfferOutcome') {
        cfObj.fieldName = 'clientOutcome';
    } else if (action === 'saveOfferDeliverables') {
        cfObj.fieldName = 'deliverables';
    } else if (action === 'saveOfferBestFit') {
        cfObj.fieldName = 'bestFitFor';
    } else if (action === 'saveOfferDeliveryWindow') {
        cfObj.fieldName = 'deliveryWindow';
    } else if (action === 'saveOfferPaymentBasis') {
        cfObj.fieldName = 'paymentBasis';
    } else if (action === 'saveOfferFirstStep') {
        cfObj.fieldName = 'firstStepType';
    } else if (action === 'saveOfferTakeaway') {
        cfObj.fieldName = 'firstStepTakeaway';
    } else if (action === 'saveOfferPriceFlex') {
        cfObj.fieldName = 'priceFlexibility';
    } else if (action === 'saveOfferValEx') {
        cfObj.fieldName = 'valueExchangeAccepted';
    } else if (action === 'saveOfferResponse') {
        cfObj.fieldName = 'responseTime';
    } else if (action === 'saveOfferSlots') {
        cfObj.fieldName = 'slotsOpen';
    } else if (action === 'saveOfferNotUseful') {
        cfObj.fieldName = 'ifNotUseful';
    } else if (action === 'saveOfferWhoNotFor') {
        cfObj.fieldName = 'whoNotFor';
    } else if (action === 'saveOfferClientProvides') {
        cfObj.fieldName = 'clientProvides';
    } else if (action === 'saveOfferNotIncluded') {
        cfObj.fieldName = 'notIncluded';
    } else if (action === 'saveOfferProfileColor') {
        cfObj.fieldName = 'profileColor';
        
    } else {
        cfObj.fieldName = null;
        cfObj.fieldValueIsNull = true;
        cfObj.collectionName = null;
        cfObj.vuexServiceName = null;
    }
    
    return cfObj;
}

export function saveOfferFieldService(payload) {
    const isUserLoggedIn = payload.isUserLoggedIn;
    const action = payload.action;
    const currentThis = payload.currentThis;
    const localData = payload.localData;
    const offerId = payload.offerId;

    const cfObj = checkInputFieldService(localData, action);

    if (!isUserLoggedIn || cfObj.fieldValueIsNull) {
        return;
    }

    currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", true);

    const fieldName = cfObj.fieldName;
    const dataObj = {};

    // 1. Format the data properly (Handles Arrays, Numbers, Booleans, Strings)
    if (localData[`${fieldName}`] !== undefined && localData[`${fieldName}`] !== null && localData[`${fieldName}`] !== '') { 
        if (Array.isArray(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = localData[`${fieldName}`]; 
        } else if(isInteger(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Number(localData[`${fieldName}`].toString().trim());
        } else if(isBoolean(localData[`${fieldName}`])) {
            dataObj[`${fieldName}`] = Boolean(localData[`${fieldName}`].toString().trim());
        } else {
            dataObj[`${fieldName}`] = localData[`${fieldName}`].trim();
        }
    } else {
        dataObj[`${fieldName}`] = null;
    }

    // 2. DIRECT API CALL (Bypasses missing Vuex Actions)
    axios.patch(`https://parser.ai.getboarded.com/api/offers/${offerId}`, dataObj)
        .then((res) => {
            // 3. Update the main Vuex state list so the UI reflects the change immediately
            const offersList = currentThis.$store.state.editor.offers;
            const index = offersList.findIndex(o => o._id === offerId);
            if (index !== -1) {
                offersList[index][fieldName] = dataObj[fieldName];
            }
            
            currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
        })
        .catch((err) => {
            console.error("Failed to save field:", err);
            currentThis.$store.commit("editor/TOGGLE_SAVE_IN_PROGRESS", false);
        });
}

export function deleteOfferService(payload) {
    const currentThis = payload.currentThis;
    const offerId = payload.offerId;

    currentThis.$store.dispatch('editor/deleteOffer', offerId).then((res) => {
        successNotifyService({currentThis, title: 'Offer Deleted', text: 'This Offer has been successfully deleted from your profile.'})
    }).catch(err => {
        throw err;
    });
}

export function updateOfferImageService(payload) {
    const imgInput = payload.imgInput;
    const offerId = payload.offerId;
    const currentThis = payload.currentThis;
    const maxSize = payload.maxSize; // In MB

    if (imgInput.target.files && imgInput.target.files[0]) {
        const file = imgInput.target.files[0];
        
        const parts = file.name.split(".");
        const ext = parts[parts.length - 1].toLowerCase();

        // Check for correct image file type
        if (ext !== "jpg" && ext !== "jpeg" && ext !== "png" && ext !== "webp") {
            failureNotifyService({
                title: "Incorrect File Type",
                text: "Please upload a supported image file type, e.g. jpg, png, webp etc.",
                currentThis
            });
            return;
        }

        // Check for image file size
        if (file.size / (1024 * 1024) > maxSize) {
            failureNotifyService({
                title: "Image File Size Exceeded",
                text: `The size of the offer picture should be less than ${maxSize}MB.`,
                currentThis
            });
            return;
        }

        // Start global loading spinner (Removed the hardcoded missing container ID)
        currentThis.$vs.loading({
            color: "primary",
            background: "rgba(255,255,255,0.8)",
            scale: 0.8,
        });

        // Use FormData to send file to FastAPI
        const formData = new FormData();
        formData.append('file', file);

        axios.post(`https://parser.ai.getboarded.com/api/offers/${offerId}/image`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then((res) => {
            // 1. Add a timestamp to bypass the browser's image cache
            const newImageUrl = res.data.offerPictureUrl + '?t=' + new Date().getTime();

            // 2. Use Vue's $set to guarantee the form UI updates instantly
            currentThis.$set(currentThis.localData, 'offerPictureUrl', newImageUrl);
            
            // 3. Update the item in the top list instantly
            const index = currentThis.offers.findIndex(o => o._id === offerId);
            if (index !== -1) {
                // Clone the object to maintain perfect reactivity in arrays
                const updatedOffer = Object.assign({}, currentThis.offers[index], { offerPictureUrl: newImageUrl });
                currentThis.$set(currentThis.offers, index, updatedOffer);
            }

            // Safely close the global loading spinner
            currentThis.$vs.loading.close();
            
            successNotifyService({
                title: "Banner Uploaded", 
                text: "Offer banner successfully updated.", 
                currentThis
            });
        })
        .catch((err) => {
            console.error("Upload failed:", err);
            
            // Safely close the global loading spinner on error
            currentThis.$vs.loading.close();
            
            failureNotifyService({
                title: "Upload Failed",
                text: "Failed to upload image to server.",
                currentThis
            });
        });
    }
}